import { slug } from "@/lib/format";

export const BUCKET_LABEL = {
  current: "Belum jatuh tempo", "1-30": "Lewat 1–30 hari", "31-60": "Lewat 31–60 hari",
  "61-90": "Lewat 61–90 hari", "90+": "Lewat > 90 hari", paid: "Lunas",
};

export const bucketCls = (b) => `b-${String(b || "").replace("+", "plus")}`;

export function AgingBadge({ inv }) {
  const b = inv.aging_bucket;
  const text = b === "void" ? "Dibatalkan (nota kredit)" : b === "paid" ? "Lunas"
    : b === "current" ? (inv.days_to_due === 0 ? "Jatuh tempo hari ini" : `Jatuh tempo H-${inv.days_to_due}`)
    : `Lewat ${inv.days_overdue} hari`;
  return <span className={`aging-badge ${bucketCls(b)}`} data-testid={`aging-${inv.number}`}>{text}</span>;
}

export function InvStatus({ status, testId }) {
  return <span className={`order-status ${slug(status)}`} data-testid={testId}>{status}</span>;
}
